import { useState } from 'react';
import { css } from '@emotion/css'
import ResourcePanel from './ResourcePanel';
import SolutionsPanel from './SolutionsPanel';

const ResourceStyle = css`

  .colorlink {
      color: #FFFFFC;
      position: relative; /* Ensure pseudo-element is positioned relative to this */
      padding-right: 12px; /* Space for the arrow */

  }

  .colorlink::after {
      content: '';
      display: inline-block;
      position: absolute;
      top: 50%;
      right: 0;
      transform: translateY(-50%) rotate(45deg); /* Properly center and rotate the arrow */
      width: 6px;
      height: 6px;
      border-right: 2px solid #FFFFFC;
      border-bottom: 2px solid #FFFFFC;
      transition: transform 0.1s ease-in-out;
    }
  .rhs ul {
    display: flex; /* Use flexbox to align items */
    align-items: center; /* Vertically align items */
    list-style: none; /* Remove default list styling */
    padding: 0; /* Remove default padding */
    margin: 0; /* Remove default margin */
  }

  .rhs li {
    margin-left: 32px; /* Add spacing between list items - adjust as needed */
  }

  .rhs li:first-child {
    margin-left: 0; /* Remove margin from the first item */
  }
`;



function AppHeaderFull() {
  const [isPanelVisible, setIsPanelVisible] = useState(false);
  const [isSolutionsVisible, setIsSolutionsVisible] = useState(false);

  const handleResourcesClick = () => {
    setIsPanelVisible(!isPanelVisible);
    setIsSolutionsVisible(false); // Close others
  };

  const handleSolutionsClick = () => {
    setIsSolutionsVisible(!isSolutionsVisible);
    setIsPanelVisible(false); // Close others
  };

  return (
    <>
      <nav
        className={`flex w-full items-center justify-between ${ResourceStyle}`}
        id="nav"
        aria-label='Main Menu'
      >
        <div className="lhs">
          <a href="/">
            <img src="/header/forte-notary-logo-transparent-v2.svg" alt="Forte Notary Logo" className="h-24 w-24 mx-6" />
          </a>
        </div>

        <div className="rhs text-lg">
          <ul role="menubar">
            <li role="presentation">
              <a href="/locations" className="text-[#FFFFFC] hover:text-[#e2ba57]" role="menuitem">Locations</a>
            </li>
            <li role="presentation">
              <a href="/ralphbrooks" className="text-[#FFFFFC] hover:text-[#e2ba57]" role="menuitem">About</a>
            </li>

            {/* NEW SOLUTIONS TAB */}
            <li role="presentation">
              <span
                className="colorlink cursor-pointer text-[#FFFFFC]"
                onClick={handleSolutionsClick}
                role="menuitem"
                aria-haspopup="true"
                aria-expanded={isSolutionsVisible}
              >
                Solutions
              </span>
              <SolutionsPanel isVisible={isSolutionsVisible} />
            </li>

            <li role="presentation">
              <span
                className="colorlink cursor-pointer text-[#FFFFFC]"
                onClick={handleResourcesClick}
                role="menuitem"
                aria-haspopup="true"
                aria-expanded={isPanelVisible}
              >
                Resources
              </span>
              <ResourcePanel isVisible={isPanelVisible} />
            </li>
            <li role="presentation">
              <a href="/contact" className="text-[#FFFFFC] hover:text-[#e2ba57]" role="menuitem">Book Now</a>
            </li>
          </ul>
        </div>
      </nav>
    </>
  );
}

export default AppHeaderFull;